// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriveTimeTool.Feature {
  padding-bottom: 3rem;
  --container-fluid-padding-x: 4rem;
}
.DriveTimeTool.Feature > .container-fluid {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0 var(--container-fluid-padding-x);
}
.DriveTimeTool.Feature > .container-fluid .drive-time-header {
  padding: 1.5rem 0 0 0;
  margin-bottom: 0;
}
.DriveTimeTool.Feature > .container-fluid .drive-time-header .page-title {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.DriveTimeTool.Feature > .container-fluid .card {
  border: 1px solid #e0e0e0;
  border-radius: 1.025rem;
  box-shadow: 2px 3px 3px 0 rgba(0, 0, 0, 0.12);
  animation: cardFadeSlideIn 0.6s ease;
}
@keyframes cardFadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.DriveTimeTool.Feature > .container-fluid .card > .card-header {
  border-radius: 1.025rem 1.025rem 0 0;
}
.DriveTimeTool.Feature > .container-fluid .card .LoadingBlur {
  border-radius: 1.025rem;
}
.DriveTimeTool.Feature > .container-fluid .DriveTimeTool-Footer {
  text-align: center;
}
.DriveTimeTool.Feature .submit-btn {
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: center;
}
.DriveTimeTool.Feature .submit-btn .search-icon-btn {
  font-size: 14px;
  color: white;
}
.DriveTimeTool.Feature .DriveTimeTool-History .History,
.DriveTimeTool.Feature .DriveTimeTool-History .History .card,
.DriveTimeTool.Feature .DriveTimeTool-History .Map,
.DriveTimeTool.Feature .DriveTimeTool-History .Map .card,
.DriveTimeTool.Feature .DriveTimeTool-MapDisplay .History,
.DriveTimeTool.Feature .DriveTimeTool-MapDisplay .History .card,
.DriveTimeTool.Feature .DriveTimeTool-MapDisplay .Map,
.DriveTimeTool.Feature .DriveTimeTool-MapDisplay .Map .card {
  height: 100%;
}
.DriveTimeTool.Feature .divider .vr {
  height: 4rem;
  background: #e3e8ef;
  opacity: 1;
}
.DriveTimeTool.Feature .divider .badge {
  border: 1px solid #e3e8ef;
  background: #f2f2f2;
  font-weight: 600;
  --bs-badge-padding-x: 0.6rem;
  --bs-badge-padding-y: 0.3rem;
}
.DriveTimeTool.Feature .BubbleTitle {
  position: relative;
  padding-top: 1.5rem;
  animation: cardFadeSlideIn 0.6s ease;
}
.DriveTimeTool.Feature .BubbleTitle .BubbleTitle-Bubble {
  text-wrap: nowrap;
  position: absolute;
  top: -2.4rem;
  left: calc(50% - 2 * var(--container-fluid-padding-x));
}

#PageFilters .PageNavigation {
  display: flex;
  justify-content: end;
  padding: 0.5rem 0;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/styles.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,iCAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,2CAAA;AAEJ;AAAI;EACE,qBAAA;EACA,gBAAA;AAEN;AAAM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AAER;AACI;EACE,yBAAA;EACA,uBAAA;EACA,6CAAA;EACA,oCAAA;AACN;AACM;EACE;IACE,UAAA;IACA,2BAAA;EACR;EACM;IACE,UAAA;IACA,wBAAA;EACR;AACF;AACM;EACE,oCAAA;AACR;AACM;EACE,uBAAA;AACR;AAEI;EACE,kBAAA;AAAN;AAIE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;AAFJ;AAII;EACE,eAAA;EACA,YAAA;AAFN;AASM;;;;;;;;EAEE,YAAA;AADR;AAMI;EACE,YAAA;EACA,mBAAA;EACA,UAAA;AAJN;AAMI;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,4BAAA;AAJN;AAQE;EACE,kBAAA;EACA,mBAAA;EACA,oCAAA;AANJ;AAOI;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,sDAAA;AALN;;AAUE;EACE,aAAA;EACA,oBAAA;EACA,iBAAA;AAPJ","sourcesContent":[".DriveTimeTool.Feature {\n  padding-bottom: 3rem;\n  --container-fluid-padding-x: 4rem;\n  > .container-fluid {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding: 0 var(--container-fluid-padding-x);\n\n    .drive-time-header {\n      padding: 1.5rem 0 0 0;\n      margin-bottom: 0;\n\n      .page-title {\n        font-size: 2rem;\n        font-weight: 600;\n        color: #333;\n        margin: 0;\n      }\n    }\n    .card {\n      border: 1px solid #e0e0e0;\n      border-radius: 1.025rem;\n      box-shadow: 2px 3px 3px 0 rgba(0, 0, 0, 0.12);\n      animation: cardFadeSlideIn 0.6s ease;\n\n      @keyframes cardFadeSlideIn {\n        from {\n          opacity: 0;\n          transform: translateY(1rem);\n        }\n        to {\n          opacity: 1;\n          transform: translateY(0);\n        }\n      }\n      > .card-header {\n        border-radius: 1.025rem 1.025rem 0 0;\n      }\n      .LoadingBlur {\n        border-radius: 1.025rem;\n      }\n    }\n    .DriveTimeTool-Footer {\n      text-align: center;\n    }\n  }\n\n  .submit-btn {\n    padding: 12px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    justify-content: center;\n\n    .search-icon-btn {\n      font-size: 14px;\n      color: white;\n    }\n  }\n  .DriveTimeTool-History,\n  .DriveTimeTool-MapDisplay {\n    .History,\n    .Map {\n      &,\n      .card {\n        height: 100%;\n      }\n    }\n  }\n  .divider {\n    .vr {\n      height: 4rem;\n      background: #e3e8ef;\n      opacity: 1;\n    }\n    .badge {\n      border: 1px solid #e3e8ef;\n      background: #f2f2f2;\n      font-weight: 600;\n      --bs-badge-padding-x: 0.6rem;\n      --bs-badge-padding-y: 0.3rem;\n    }\n  }\n\n  .BubbleTitle {\n    position: relative;\n    padding-top: 1.5rem;\n    animation: cardFadeSlideIn 0.6s ease;\n    .BubbleTitle-Bubble {\n      text-wrap: nowrap;\n      position: absolute;\n      top: -2.4rem;\n      left: calc(50% - (2 * var(--container-fluid-padding-x)));\n    }\n  }\n}\n#PageFilters {\n  .PageNavigation {\n    display: flex;\n    justify-content: end;\n    padding: 0.5rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
